import {Injectable} from '@angular/core';
import {NotificationItem} from '../../routes/notification/notification.model';
import {HttpService} from './http.service';
import {UserService} from './user.service';
import {Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  unreadNotificationCountSubject: Subject<number> = new Subject<number>();
  unreadNotificationCount: number;
  notificationArray: NotificationItem[];
  pageIndex: number;
  pageSize: number;
  length: number;

  constructor(private httpService: HttpService, private userService: UserService) {
    this.unreadNotificationCount = 0;
    this.notificationArray = [];
    this.pageIndex = 0;
    this.pageSize = 0;
    this.length = 0;
  }

  // 从数据库获取 消息
  getNotification(status, page, pageSize) {
    return new Promise((resolve) => {
      this.httpService.getNotificationByAuth(status, page, pageSize).toPromise().then((res: any) => {
        this.notificationArray = res.data?.content;
        this.pageIndex = res.data?.pageable.pageNumber;
        this.pageSize = res.data?.pageable.pageSize;
        this.length = res.data?.totalElements;
        this.checkUnreadNotification().then(() => {
          resolve();
        });
      });
    });
  }

  // 从数据库查看 未读消息数量
  checkUnreadNotification() {
    this.unreadNotificationCount = 0;
    return new Promise((resolve) => {
      this.httpService.getUnreadNotification().toPromise().then((res: any) => {
        this.unreadNotificationCount = res.data?.count;
        resolve(this.unreadNotificationCount);
      });
    });
  }

  // 解析并查找notification receiver 获取当前用户的消息
  getCurrentReceiver(notificationReceivers) {
    const firstName = this.userService.getCurrentUser().firstName;
    const lastName = this.userService.getCurrentUser().lastName;
    for (const eachReceiver of notificationReceivers) {
      if (eachReceiver.receiver?.firstName === firstName && eachReceiver.receiver?.lastName === lastName) {
        return eachReceiver;
      }
    }
    console.log('notification receiver not found');
    return undefined;
  }

  /**
   * @author Damon Gao
   * @description pass the notification number
   * @param count unread notification number
   */
  updateUnreadNotificationCount(count: number) {
    this.unreadNotificationCount = count;
    this.unreadNotificationCountSubject.next(count);
  }
}
